<template>
  <div id="room">
    <div v-if="room === null" id="loading">
      <div class="preloader-wrapper big active">
        <div class="spinner-layer spinner-pink-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div>
        </div>
      </div>
      <div>読み込み中...</div>
    </div>
    <div v-else-if="!room.is_readable">
      <NotFound />
    </div>
    <div v-else>
      <TheTopbar :is_login="is_login" :room="room" :current_user_nickname="current_user_nickname" />
      <RoomMessageList :is_login="is_login" :current_user_id="current_user_id" />
      <div>
        <TheBottombar
          v-if="room.is_postable"
          :is_login="is_login"
          :current_user_id="current_user_id"
          :current_user_nickname="current_user_nickname"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TheTopbar from "./TheTopbar";
import RoomMessageList from "./RoomMessageList";
import TheBottombar from "./TheBottombar";
import NotFound from "../error/NotFound";

import { db, auth } from "./../../App.vue";
import cookie from "js-cookie";
import materialize from "materialize-css";
import filterXSS from "xss";

export default {
  name: "Room",
  components: {
    TheTopbar,
    RoomMessageList,
    TheBottombar,
    NotFound
  },
  data: function() {
    return {
      is_login: false,
      current_user_id: null,
      current_user_nickname: null,
      room: null
    };
  },
  computed: {
    roomId: function() {
      return this.$route.params.room_id;
    }
  },
  created: function() {
    let self = this;
    db.ref(`rooms/${this.roomId}`)
      .once("value")
      .then(function(snapshot) {
        self.room = snapshot.val();
      })
      .catch(function() {
        self.room = {};
        self.room["is_readable"] = false;
      });
    auth.onAuthStateChanged(function(user) {
      if (user) {
        self.is_login = true;
        self.current_user_id = user.uid;
        user.getIdTokenResult().then(function(id_token_result) {
          self.current_user_nickname = id_token_result.claims.nickname;
          materialize.toast({
            html: filterXSS(
              `${self.base64Decode(self.current_user_nickname)} さん ようこそ！`
            ),
            displayLength: 3000
          });
        });
      } else {
        if (
          cookie.get("sid") != undefined &&
          cookie.get("rsp_logouted") == undefined &&
          cookie.get("rsp_fail_to_login") == undefined
        ) {
          // すでに www.3ple.jp にログイン済み、
          // かつRSPチャットでログアウトしていない、
          // かつRSPチャットでログイン失敗していない場合は、自動ログイン
          window.location.href = `/login?redirectRoomId=${self.roomId}`;
          return;
        }
        self.is_login = false;
        self.current_user_id = null;
        self.current_user_nickname = null;
      }
    });
  },
  methods: {
    base64Decode: function(encoded) {
      return decodeURIComponent(escape(window.atob(encoded)));
    }
  }
};
</script>
<style lang="scss" scoped>
#loading {
  margin: 0;
  position: absolute;
  top: 45%;
  width: 100%;
  text-align: center;
}
</style>
